import { Typography, Grid, Paper, IconButton, Tooltip } from '@mui/material';
import { i18n } from '../../translate/i18n';
import {
    Position,
    Node,
    Edge,
    ReactFlowProvider,
} from 'reactflow';
import '@xyflow/react/dist/style.css';
import { ElementsLiteBot } from './menu';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { ConexaBotVariablesProvider } from '../../hooks/useConexaBotVariables';
import FlowCanvas from './flowCanvas';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import InstagramIcon from '@material-ui/icons/Instagram';
import VerifiedIcon from '@mui/icons-material/Verified';

export interface INode extends Node {
    id: string;
    position: { x: number; y: number };
    type: "start" | "condition" | "end";
    data: {
        id: string,
        label: string,
        type: "start" | "condition" | "end",
        subtype: "start" | "transfer" | "finish" | "question" | "message" | "simpleCondition" | "compoundCondition" | "await" | "variable" | "quickReply" | "openingHour",
        message?: string,
        question?: string,
        variable?: string,
        departmentId?: number,
        quickReplyId?: number,
        openingHourId?: number,
        await?: string,
        simpleCondition?: {
            variable: string,
            operator: "equalTo" | "notEqual" | "contain" | "doesNotContain" | "greaterThan" | "greatherOrEqualTo" | "lessThan" | "lessOrEqualTo" | "isEmpty" | "isCPF" | "isCEP" | "isCNPJ" | "isPhone" | "",
            value: string
        };
        compoundCondition?: { variable: string, options: { id: string, name: string, value: string[] }[] };
        conclusionMessageId?: number,
    };
    sourcePosition?: Position;
    targetPosition?: Position;
}

// interface IEdge extends Edge {
//     id: string;
//     source: string;
//     target: string;
// }

interface IManagerConexaBot {
    id: number;
    name: string;
    initialNodes: INode[];
    initialEdges: any[];
    initialVariables: string[];
    departments: any[] | null;
    quickReplies: any[] | null;
    conclusionMessages: any[] | null;
    openingHours: any[] | null;
    connection: any | null;
}

const ManagerConexaBot = ({ id, name, initialNodes, initialEdges, departments, initialVariables, quickReplies, conclusionMessages, openingHours, connection }: IManagerConexaBot) => {

    const VariablesManager = ({ children }: { children: React.ReactNode }) => {
        return (
            <ConexaBotVariablesProvider initial={initialVariables}>
                {children}
            </ConexaBotVariablesProvider>
        );
    }

    return (
        <Paper
            sx={{
                margin: "0 2 2 2",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 170px)",
                maxWidth: "calc(100vw - 40px)",
                bgcolor: "transparent",
                boxShadow: "none",
            }}
        >
            <VariablesManager>
                {/* título */}
                <Grid container spacing={2} p={2} style={{ paddingBottom: 0 }}>
                    <Grid
                        item
                        xs={12}
                        style={{
                            position: "relative",
                            marginBottom: 0,
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        {/* Ícone */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minHeight: "72px",
                                marginRight: "12px"
                            }}
                        >
                            {[1, 4].includes(connection?.moduleId) && (
                                <WhatsAppIcon
                                    style={{
                                        color: "#25D366",
                                        width: "50px",
                                        height: "50px"
                                    }}
                                />
                            )}

                            {connection?.moduleId === 2 && (
                                <InstagramIcon
                                    style={{
                                        color: "#C13584",
                                        width: "50px",
                                        height: "50px"
                                    }}
                                />
                            )}

                            {connection?.moduleId === 3 && (
                                <VerifiedIcon
                                    style={{
                                        color: "#49ADF4",
                                        width: "50px",
                                        height: "50px"
                                    }}
                                />
                            )}
                        </div>

                        {/* Textos */}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Typography
                                variant="h5"
                                style={{
                                    fontWeight: 600,
                                    color: "rgb(11, 112, 140)",
                                    fontSize: "1.3rem",
                                    lineHeight: 1.2
                                }}
                            >
                                Conexão: {connection?.name || ""}
                            </Typography>

                            <Typography
                                variant="h6"
                                component="h2"
                                style={{
                                    fontSize: "1.1rem",
                                    textTransform: "capitalize",
                                    lineHeight: 1.2
                                }}
                            >
                                {name || "ConexaBot Name"}
                            </Typography>
                        </div>

                        {/* Botão menu */}
                        <Tooltip title={i18n.t("conexaBots.elementsMenu.title")}>
                            <IconButton
                                sx={{
                                    position: "absolute",
                                    right: "0px",
                                    top: "50%",
                                    transform: "translateY(-50%)"
                                }}
                                onClick={() => {
                                    const menu = document.getElementById("elementsLiteBotMenu");
                                    if (menu) menu.style.display = "flex";
                                }}
                            >
                                <MenuOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>

                {/* área do flow */}
                <Grid container sx={{ flex: 1, minHeight: 400, position: "relative" }} p={2}>
                    <Grid item xs={12} sx={{ height: '100%' }}>
                        <ReactFlowProvider>
                            <FlowCanvas
                                conexaBotId={id}
                                name={name}
                                initialNodes={initialNodes}
                                initialEdges={initialEdges}
                                departments={departments}
                                quickReplies={quickReplies}
                                conclusionMessages={conclusionMessages}
                                openingHours={openingHours}
                            />
                        </ReactFlowProvider>
                    </Grid>
                </Grid>

                <ElementsLiteBot />
            </VariablesManager>
        </Paper>
    );
}

export default ManagerConexaBot;
